"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _dayjs = _interopRequireDefault(require("dayjs")),
    _advancedFormat = _interopRequireDefault(require("dayjs/plugin/advancedFormat"));

_dayjs.default.extend(_advancedFormat.default);

var _default = function _default() {
  return (
    /*#__PURE__*/

    /**
    * Format a timestamp as a string
    *
    * @param {*} timestamp Unix timestamp in seconds
    * @param {string} [format='MMM. Do YYYY'] Format for the date, defaults to a format like "Jan. 1st 2000"
    *
    * @return {Promise<radspec/evaluator/TypedValue>}
    */
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(timestamp) {
        var format,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                format = _args.length > 1 && _args[1] !== undefined ? _args[1] : "MMM. Do YYYY";
                return _context.abrupt("return", {
                  type: "string",
                  value: (0, _dayjs.default)(new Date(1e3 * +timestamp)).format(format)
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

exports.default = _default;